import { useRive } from '@rive-app/react-webgl2';

const RiveWrapper = () => {
  const { RiveComponent } = useRive({
    src: "/final-bg-lines.riv",
    autoplay: true,
  });
  return (
    <RiveComponent
      className="w-full h-full object-fill"
    />
  );
};

export default RiveWrapper;
